<html>

    <body class="dx-viewport">
        
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->  
        <dx-box
            direction="row"
            width="100%"
            [height]="formheight"
        > 
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="1.0"
            >
                <dx-box
                    direction="col"
                    width="100%"
                    height="100%"
                >
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxi-item
                        [ratio]="1.0"
                    >
                        <dx-data-grid 
                            #grideventparticipants
                            id="grideventparticipants"
                            keyExpr="id"
                            [dataSource]="subscriptioneventparticipantlist"    

                            [allowColumnReordering]="false"
                            [allowColumnResizing]="true"
                            [showRowLines]="true"
                            [showColumnLines]="false"
                            [showBorders]="true"
                            [repaintChangesOnly]="true"
                            [focusedRowEnabled]="true"
                            [autoNavigateToFocusedRow]="true"
                            [focusedRowEnabled]="true"

                            (onCellPrepared)="datagrideditorPreparing( $event )" 
                            (onRowClick)="onrowparticipantclick($event)"
                            (onFocusedRowChanged)="onrowparticipantchange($event)"

                            width="100%"
                            height="98%"
                        >
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxo-filter-row
                                [visible]="false"
                            >
                            </dxo-filter-row>

                            <dxo-sorting
                                mode="single"> <!-- or "multiple" | "none" -->
                            </dxo-sorting>

                            <dxo-selection
                                mode="single"
                            >
                            </dxo-selection>

                            <dxo-load-panel
                                [enabled]="false">
                            </dxo-load-panel>

                            <dxo-editing 
                                mode="popup"                            
                                [allowUpdating]="true"
                                [allowDeleting]="true"
                                [allowAdding]="true"
                                [useIcons]="true"
                            >
                            </dxo-editing>
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxi-column
                                dataField="firstname"
                                caption="First Name/Category"
                                [allowEditing]="true" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%">

                                    <dxi-validation-rule 
                                        type="required"
                                        message="Please enter First Name/Category">
                                    </dxi-validation-rule>

                            </dxi-column>   

                            <dxi-column
                                dataField="lastname"
                                caption="Last Name/Category"
                                [allowEditing]="true" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >
                                    <dxi-validation-rule 
                                        type="required"
                                        message="Please enter Last Name/Category">
                                    </dxi-validation-rule>

                            </dxi-column>  

                            <dxi-column
                                dataField="identity"
                                caption="ShortName"
                                [allowEditing]="true" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >
                                    <dxi-validation-rule 
                                        type="required"
                                        message="Please enter abbreviation">
                                    </dxi-validation-rule>

                            </dxi-column> 
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxo-toolbar>
                                <dxi-item location="after">
                                    <div *dxTemplate>

                                        <dx-button
                                            text="Add"
                                            icon="refresh" 
                                            (onClick)="participantform( $event, 10)"
                                        >

                                        </dx-button>

                                        <dx-button
                                            text="Edit"
                                            icon="refresh" 
                                            [disabled]="buttondisable"
                                            (onClick)="participantform( $event, 20)"
                                        >
                                        </dx-button>
                                    </div>
                                </dxi-item>
                            </dxo-toolbar>
                            <!------------------------------------------------------------------------->
                        </dx-data-grid>

                    </dxi-item>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxi-item
                        [ratio]="0.001">
                    </dxi-item> 
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxi-item
                        class="rectangleinfosquare"
                        [ratio]="1.0"
                    >

                        {{selorgid}}
                        Snapshot
                        Event date
                        Event Location
                        Event Guest Invite: Guest Coming: Guest Not Coming
                        Event Budget: Budget Amount: Actual Amount
                        Plus any other stats that I can think off

                    </dxi-item>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                </dx-box>
        
            </dxi-item>   
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="0.005"
            >
            </dxi-item> 
             <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="1.0"
            >
             
                <dx-scroll-view
                    #scrollView
                    id="scrollview"
                
                    height="100%"
                    width="100%"

                    [useNative]="true"

                    showScrollbar="always"

                    direction="both"
                >
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dx-box
                        direction="col"
                        width="100%"
                        height="100%"
                    >
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        <dxi-item
                            [ratio]="1.0"
                        >
                       
                            <div class="tp-box" (click)="toggleFlip(1)" [@flipguest]="flipguest">

                                <div class="tp-box__side tp-box__front">

                                   <div class="vertical-center">
                                        <div id="elementonelinemaxcontent">
                                            <div [innerHTML]="setcardcommentary(1)"></div>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div class="tp-box__side tp-box__back">

                                        <div class="vertical-center">

                                            <div id="elementoneline">

                                                <div class="floatlabel301 floatlabel305">

                                                    <dx-validation-group #targetGroupGuestNo>

                                                        <dx-number-box
                                                            #guestno
                                            
                                                            format="#,##0"
                                                            [(value)]="selnoguestinvite"

                                                            width="150px"
                                                            height="50px"

                                                            [elementAttr]="{ class: 'fontsize15' }"

                                                            label="No of Guest Invited:"
                                                            labelMode="floating"

                                                            [min]="0"

                                                            (onFocusIn)="inputonclickstatus( $event,true )"
                                                            (onFocusOut)="inputonclickstatus($event,false )"

                                                            (onInput)="inputchanged( $event )"
                                                            (onValueChanged)="valuechanged( $event, 1)"

                                                        >
                                                            <dx-validator>
                                                                <dxi-validation-rule 
                                                                    type="custom" 
                                                                    [reevaluate]="true"  
                                                                    [validationCallback]="validatenumberinput"  
                                                                    message="Guest invite cannot be 0">
                                                                </dxi-validation-rule>
                                                            </dx-validator>
                                                        
                                                        </dx-number-box>

                                                    </dx-validation-group>
                                                    
                                                </div>

                                                <dx-button
                                                    width="50px"
                                                    height="51px"
                                                    icon="fa-sharp fa-solid fa-check"
                                                    [elementAttr]="{ class: 'buttonformat01' }"
                                                    (onClick)="infoclick($event, 1, 0)"
                                                >
                                                </dx-button>

                                                <dx-button
                                                    width="50px"
                                                    height="51px"
                                                    icon="fa-sharp fa-solid fa-xmark"
                                                    [elementAttr]="{ class: 'buttonformat01' }"
                                                    [disabled] = "statusvisible()"
                                                
                                                    (onClick)="infoclick($event, 1, 1)"

                                                >
                                                </dx-button>

                                            </div>

                                        </div>

                                </div>

                            </div>
                               
                        </dxi-item>  
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        <dxi-item
                            [ratio]="0.01"
                        >
                        </dxi-item>  
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        <dxi-item
                            [ratio]="1.0"
                        >

                            <div class="tp-box" (click)="toggleFlip(10)" [@flipbudget]="flipbudget">

                                <div class="tp-box__side tp-box__front">

                                    <div class="vertical-center">
                                        <div id="elementonelinemaxcontent">
                                            <div [innerHTML]="setcardcommentary(10)"></div>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div class="tp-box__side tp-box__back">
                                    
                                        <div class="vertical-center">

                                            <div id="elementoneline">

                                                <div class="floatlabel301 floatlabel305">

                                                    <dx-validation-group #targetGroupBudget>

                                                        <dx-number-box
                                                            #budget
                                            
                                                            format="#,##0"
                                                            [(value)]="selbudgetamount"

                                                            width="150px"
                                                            height="50px"

                                                            [elementAttr]="{ class: 'fontsize15' }"

                                                            label="Budget Amount:"
                                                            labelMode="floating"

                                                            [min]="0"

                                                            (onFocusIn)="inputonclickstatus( $event, true )"
                                                            (onFocusOut)="inputonclickstatus($event, false )"

                                                            (onInput)="inputchanged( $event )"
                                                            (onValueChanged)="valuechanged( $event, 10)"
                                                           
                                                        >
                                                            <dx-validator>
                                                                <dxi-validation-rule 
                                                                    type="custom" 
                                                                    [reevaluate]="true"  
                                                                    [validationCallback]="validatenumberinput"  
                                                                    message="Budget amount cannot be 0"
                                                                >
                                                                </dxi-validation-rule>
                                                            </dx-validator>
                                                        
                                                        </dx-number-box>

                                                    </dx-validation-group>
                                                    
                                                </div>

                                                <dx-button
                                                    width="50px"
                                                    height="51px"
                                                    icon="fa-sharp fa-solid fa-check"
                                                    [elementAttr]="{ class: 'buttonformat01' }"
                                                    (onClick)="infoclick($event, 10, 0)"
                                                >
                                                </dx-button>

                                                <dx-button
                                                    width="50px"
                                                    height="51px"
                                                    icon="fa-sharp fa-solid fa-xmark"
                                                    [elementAttr]="{ class: 'buttonformat01' }"

                                                    [disabled] = "statusvisible()"
                                                    (onClick)="infoclick($event, 10, 1)"
                                                >
                                                </dx-button>

                                            </div>

                                        </div>
                                    
                                </div>

                            </div>
                            
                        </dxi-item>  
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        <dxi-item
                            [ratio]="0.01"
                        >
                        </dxi-item>  
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        <dxi-item
                            [ratio]="1.0"
                        >
                            
                            <div class="tp-box" (click)="toggleFlip(20)" [@flipevent]="flipevent">
                                    
                                <div class="tp-box__side tp-box__front">

                                    <div class="vertical-center">
                                        <div id="elementonelinemaxcontent">
                                            <div [innerHTML]="setcardcommentary(20)"></div>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div class="tp-box__side tp-box__back">
                                    
                                    <div class="vertical-center">

                                        <div id="elementoneline">

                                            <div class="floatlabel301 floatlabel305">

                                                <dx-validation-group #targetGroupEventName>

                                                    <dx-text-box 
                                                        #eventype
                                                        [(value)] = "seleventtype"
                                                        
                                                        width="200px"
                                                        height="51px"

                                                        [elementAttr]="{ class: 'fontsize15' }"

                                                        label="Event Type i.e Wedding:"
                                                        labelMode="floating"
        
                                                        (onFocusIn)="inputonclickstatus( $event,true )"
                                                        (onFocusOut)="inputonclickstatus($event,false )"
                                                        
                                                    >

                                                        <dx-validator>
                                                            <dxi-validation-rule 
                                                                type="custom" 
                                                                [reevaluate]="true"  
                                                                [validationCallback]="validatetextinput"  
                                                                message="Event cannot be blank"
                                                            >
                                                            </dxi-validation-rule>
                                                        </dx-validator>
                                                
                                                    </dx-text-box>

                                                </dx-validation-group>
                                                
                                            </div>

                                            <dx-button
                                                width="50px"
                                                height="51px"
                                                icon="fa-sharp fa-solid fa-check"
                                                [elementAttr]="{ class: 'buttonformat01' }"
                                                (onClick)="infoclick($event, 20, 0)"
                                            >
                                            </dx-button>

                                            <dx-button
                                                width="50px"
                                                height="51px"
                                                icon="fa-sharp fa-solid fa-xmark"
                                                [elementAttr]="{ class: 'buttonformat01' }"

                                                [disabled] = "statusvisible()"
                                                (onClick)="infoclick($event, 20, 1)"

                                            >
                                            </dx-button>

                                        </div>

                                    </div>
                                
                                </div>

                            </div>

                        </dxi-item> 
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        <dxi-item
                            [ratio]="0.01"
                        >
                        </dxi-item>
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        <dxi-item
                            [ratio]="1.0"
                        >
                            
                            <div class="tp-box" (click)="toggleFlip(30)" [@flipeventlocation]="flipeventlocation">
                                        
                                <div class="tp-box__side tp-box__front">

                                    <div class="vertical-center">
                                        <div id="elementonelinemaxcontent">
                                            <div [innerHTML]="setcardcommentary(30)"></div>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div class="tp-box__side tp-box__back">

                                    <div class="vertical-center">

                                        <div id="elementoneline">

                                            <div class="floatlabel301 floatlabel305">

                                                <dx-validation-group #targetGroupEventLocation>

                                                    <dx-text-box 
                                                        #eventlocation
                                                        [(value)] = "seleventlocation"
                                                        
                                                        width="300px"
                                                        height="51px"

                                                        [elementAttr]="{ class: 'fontsize15' }"

                                                        label="Event Location"
                                                        labelMode="floating"
        
                                                        (onFocusIn)="inputonclickstatus( $event,true )"
                                                        (onFocusOut)="inputonclickstatus($event,false )"
                                                        (onInput)="inputchanged( $event )"
                                                    >

                                                        <dx-validator>
                                                            <dxi-validation-rule 
                                                                type="custom" 
                                                                [reevaluate]="true"  
                                                                [validationCallback]="validatetextinput"  
                                                                message="Event Location cannot be blank"
                                                            >
                                                            </dxi-validation-rule>
                                                        </dx-validator>
                                                
                                                    </dx-text-box>

                                                </dx-validation-group>
                                                
                                            </div>

                                            <dx-button
                                                width="50px"
                                                height="51px"
                                                icon="fa-sharp fa-solid fa-check"
                                                [elementAttr]="{ class: 'buttonformat01' }"
                                                (onClick)="infoclick($event, 30, 0)"
                                            >
                                            </dx-button>

                                            <dx-button
                                                width="50px"
                                                height="51px"
                                                icon="fa-sharp fa-solid fa-xmark"
                                                [elementAttr]="{ class: 'buttonformat01' }"

                                                [disabled] = "statusvisible()"
                                                (onClick)="infoclick($event, 30, 1)"

                                            >
                                            </dx-button>

                                        </div>

                                    </div>
                                    
                                </div>

                            </div>

                        </dxi-item>  
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        <dxi-item
                            [ratio]="0.01"
                        >
                        </dxi-item>
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        <dxi-item
                            [ratio]="1.0"
                        >
                              
                            <div class="tp-box" (click)="toggleFlip(40)" [@flipeventdate]="flipeventdate">
                                            
                                <div class="tp-box__side tp-box__front">

                                    <div class="vertical-center">
                                        <div id="elementonelinemaxcontent">
                                            <div [innerHTML]="setcardcommentary(40)"></div>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div class="tp-box__side tp-box__back">
                                   
                                    <div class="vertical-center">

                                        <div id="elementoneline">

                                            <div class="floatlabel301 floatlabel305">

                                                <dx-validation-group #targetGroupEventDate>
                                                    <!------------------------------------------------------------------------->
                                                    <div id="elementoneline">
                                                        <dx-date-box
                                                            #eventrsvpdate
                                                            
                                                            [(value)] ="seleventrsvpdate"

                                                            [displayFormat]="localedateformat "

                                                            type="date" 
                                                            [acceptCustomValue]=false                                           

                                                            label="Rsvp Date"
                                                            labelMode="floating"

                                                            width="150px"
                                                            height="51px"

                                                            disable="true"

                                                            (onFocusIn)="inputonclickstatus( $event,true )"
                                                            (onFocusOut)="inputonclickstatus($event,false )"
                                                            (onValueChanged)="inputchanged( $event )"
                                                        > 
                                                        
                                                        </dx-date-box>
                                                        &nbsp;
                                                        <!------------------------------------------------------------------------->
                                                    
                                                        <dx-date-box
                                                            #eventdate
                                                            
                                                            [(value)] ="seleventdate"

                                                            [displayFormat]="localedateformat "

                                                            type="date" 
                                                            [acceptCustomValue]=false                                           

                                                            label="Event Date"
                                                            labelMode="floating"

                                                            width="150px"
                                                            height="51px"

                                                            disable="true"

                                                            (onFocusIn)="inputonclickstatus( $event,true )"
                                                            (onFocusOut)="inputonclickstatus($event,false )"
                                                            (onValueChanged)="inputchanged( $event )"
                                                        > 
                                                        
                                                        </dx-date-box>
                                                    </div>
                                                    <!------------------------------------------------------------------------->
                                                </dx-validation-group>

                                            </div>
                                            <!------------------------------------------------------------------------->
                                            <dx-button
                                                width="50px"
                                                height="51px"
                                                icon="fa-sharp fa-solid fa-check"
                                                [elementAttr]="{ class: 'buttonformat01' }"
                                                (onClick)="infoclick($event, 40, 0)"
                                            >
                                            </dx-button>

                                            <dx-button
                                                width="50px"
                                                height="51px"
                                                icon="fa-sharp fa-solid fa-xmark"
                                                [elementAttr]="{ class: 'buttonformat01' }"

                                                [disabled] = "statusvisible()"
                                                (onClick)="infoclick($event, 40, 1)"

                                            >
                                            </dx-button>
                                            <!------------------------------------------------------------------------->

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </dxi-item>  

                    </dx-box>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                </dx-scroll-view>
        
            </dxi-item>   
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        </dx-box>
        <!--xxxxxxxxxxxxxxxxxxxxxxPARTICIPANT POPUPxxxxxxxxxxXxxxxxxxxxxxxx-->
        <dx-popup
            id="popupformcollaborator"
            [(title)] = "popuptitle"
            [hideOnOutsideClick]="false"
            [showCloseButton]="false"
            [(visible)]="popupparticipantVisible"
            height="40%"
            width="15%"
        >
            <!------------------------------------------------------------------------->
            <dxo-position
                at="left top"
            >
                <dxo-offset
                    [x]="130" 
                    [y]="190"
                >
                </dxo-offset>
            </dxo-position>
            <!------------------------------------------------------------------------->
            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Save',
                                type: 'success',
                                onClick: saveParticipantClick
                            }"

            >
            </dxi-toolbar-item>

            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Cancel',
                                onClick: cancelParticipantClick
                            }"

            >
            </dxi-toolbar-item>
            <!------------------------------------------------------------------------->
            <dx-form 
                #formparticipant
                [(formData)]="formparticipantData"
        
                [showColonAfterLabel]="true"  
                labelMode="outside"
                labelLocation="top"

                (onFieldDataChanged)="formParticipantDatafldchange( $event )"
            
                [colCount]="1"
            >
                <!------------------------------------------------------------------------->
                <dxi-item 
                    dataField="firstname"
                    editorType="dxTextBox"
                    [editorOptions]="{ 
                                        height: 40,
                                        width: 190,  
                                        placeholder: 'Enter by First Name', 
                                        inputAttr: { autocomplete: 'chrome-off'}  
                                    }"
                    [colSpan]="1"
                >
                    <dxo-label text="First Name/Category"></dxo-label>

                    <dxi-validation-rule 
                        type="required"
                        message="First Name/Category is required"
                    >
                    </dxi-validation-rule>
                </dxi-item>
                <!------------------------------------------------------------------------->
                <dxi-item 
                    dataField="lastname"
                    editorType="dxTextBox"
                    [editorOptions]="{ 
                                        height: 40,
                                        width: 190,  
                                        placeholder: 'Enter by Last Name', 
                                        inputAttr: { autocomplete: 'chrome-off'}  
                                    }"
                    [colSpan]="1"
                >
                    <dxo-label text="Last Name/Category"></dxo-label>

                    <dxi-validation-rule 
                        type="required"
                        message="Last Name/Category is required"
                    >
                    </dxi-validation-rule>
                </dxi-item>
                <!------------------------------------------------------------------------->
                <dxi-item 
                    dataField="identity"
                    editorType="dxTextBox"
                    [editorOptions]="{ 
                                        height: 40,
                                        width: 190,  
                                        placeholder: 'Enter by Identity Abbreviation', 
                                        inputAttr: { autocomplete: 'chrome-off'}  
                                    }"
                    [colSpan]="1"
                >
                    <dxo-label text="Identity"></dxo-label>

                    <dxi-validation-rule 
                        type="required"
                        message="Identity Abbreviation is required"
                    >
                    </dxi-validation-rule>
                </dxi-item>
                <!------------------------------------------------------------------------->
           </dx-form>

        </dx-popup>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-toast
            [(message)]       =   "toastFileMessage"
            [(visible)]       =   "toastVisible"
            [type]            =   "toasttypeerror"
            [displayTime]     =   "toastdisplaytime"  
            [width]           =   "toastwidth" 
        >
            
            <dxo-position  
            >
                <dxo-at 
                    x="left" 
                    y="top">
                </dxo-at>

                <dxo-offset
                    [x]="toastposX" 
                    [y]="toastposY"
                >
                </dxo-offset>
                
            </dxo-position>

        </dx-toast>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    </body>
    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
</html>
